import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {getLocalizedAPIError, validateTicketNumber} from '../../common/util';
import Toast from '../../../Common/Toast/Toast';
import env from '../../../../util/env';
import {labels} from '../../../../util/uiconstants';
import * as manageaccessactions from '../../../../actions/admin/manageaccessactions';
import Loader from '../../../Common/Loaders/loadingindicator';
import MotifButton from '@ey/motif-react-wrapper/Button';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import TicketField from '../../common/ticketfield';

function DeactivateUser(props) {
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);
	const [deactivateUserErrorMessage, setDeactivateUserErrorMessage] =
		useState('');
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);

	const userToDeactivate = props.userToDeactivate;

	const onTicketChanged = (e) => {
		setTicketNumber(e.target.value);
	};

	const deactivateUser = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		setIsLoading(true);
		let data = {
			isActive: false
		};

		let uriTicketNumber = encodeURIComponent(ticketNumber.trim());

		let deactivateUrl =
			env.getURL('serviceUrlV2') +
			`admin/Users/${userToDeactivate.userId}/isactive?ticketNumber=${uriTicketNumber}`;

		dispatch(manageaccessactions.deactivateAdminUser(deactivateUrl, data))
			.then(() => {
				setIsLoading(false);
				props.onDeactivateModalClose(true);
			})
			.catch((result) => {
				setDeactivateUserErrorMessage(getLocalizedAPIError(result));
			})
			.finally(() => {
				setIsLoading(false);
				setIsSubmitClicked(false);
			});
	};

	return (
		<DeactivateUserWrapper className="adduser">
			<section
				className="toastMessage"
				style={{
					display:
						deactivateUserErrorMessage && deactivateUserErrorMessage.length > 0
							? 'block'
							: 'none'
				}}
			>
				<Toast
					variant="error"
					onClose={() => setDeactivateUserErrorMessage(false)}
				>
					{deactivateUserErrorMessage}
				</Toast>
			</section>
			{isLoading ? (
				<section className="deactivate-user-loader">
					<Loader show view="blockView" styleName="loadingstyle" />
				</section>
			) : (
				<section>
					<section className="content-deactivateUser customScrollbar">
						<section className="userSearch">
							<section className="result">
								<section className="warning motif-body1-default-light">
									{labels.deactivateWarning}
								</section>
								<ul className="userlist">
									<li>
										<span className="nameemail motif-body1-default-regular">
											<EllipsesControl
												content={
													userToDeactivate.displayName +
													' ' +
													'(' +
													userToDeactivate.email +
													')'
												}
												tooltip={
													userToDeactivate.displayName +
													' ' +
													'(' +
													userToDeactivate.email +
													')'
												}
												displayId={''}
												noOfLines={1}
											/>
										</span>
									</li>
								</ul>
							</section>
						</section>
						<TicketField
							ticketNumber={ticketNumber}
							onTicketChanged={onTicketChanged}
							showValidation={isSubmitClicked}
						/>
					</section>
					<section className="modal-footer">
						<MotifButton
							size="medium"
							variant="ghost"
							onClick={() => {
								props.onDeactivateModalClose(false);
							}}
						>
							{labels.cancel}
						</MotifButton>
						<MotifButton
							size="medium"
							variant="primary"
							disabled={ticketNumber.trim().length <= 0}
							onClick={() => {
								deactivateUser();
							}}
						>
							{labels.deactivateButton}
						</MotifButton>
					</section>
				</section>
			)}
		</DeactivateUserWrapper>
	);
}

const DeactivateUserWrapper = styled.section`
	//ticketstart
	.ticketdetail {
		padding: var(--spacing-x-large);
		.description {
			padding-bottom: var(--spacing-small);
		}
		.motif-form-field {
			width: var(--px-400);
		}
	}
	//ticketend
	.modal-footer {
		padding: var(--spacing-x-large);
		button {
			margin-left: var(--px-12);
		}
	}
	.deactivate-user-loader {
		padding: var(--px-24) !important;
	}
	.userSearch {
		display: flex;
		width: 100%;
		padding: var(--spacing-x-large);
		padding-bottom: 0;
		.warning {
			padding-bottom: var(--spacing-x-large);
			border-bottom: var(--px-1) solid var(--neutrals-200);
		}

		.result {
			display: inline-block;
			width: 100%;

			li {
				margin: 0;
				list-style-type: none;
				.nameemail {
					width: 100%;
					display: inline-block;
					.ellipses {
						width: 100%;
						display: inline-flex;
					}
				}
			}

			.userlist {
				width: 100%;
				display: inline-block;
				padding-top: var(--spacing-x-large);
			}
		}

		.user-selectbox .select-group {
			width: 100%;
		}
	}
	.modal-footer {
		display: inline-flex;
		width: 100%;
		justify-content: end;
		padding: var(--spacing-x-large);
		button {
			margin-left: var(--px-12);
		}
	}
`;

export default DeactivateUser;
